import * as types from './actionTypes';
import getAPIPath from '../../js/modules/api-location';
import { addNotification } from './notificationActions';

export function loadMyFoldersSuccess(folders) {
  return { type: types.LOAD_MY_FOLDERS_SUCCESS, folders };
}

export function loadMyFoldersV2Success(folders) {
  return { type: types.LOAD_MY_FOLDERS_V2_SUCCESS, folders };
}

export function loadFolderV3Success(folderIds, contents) {
  return { type: types.LOAD_FOLDER_V3_SUCCESS, folderIds, contents };
}

export function getMyFoldersSuccess(folders) {
  return { type: types.GET_MY_FOLDERS_SUCCESS, folders };
}

export function createFolderSuccess(folder) {
  return { type: types.CREATE_FOLDER_SUCCESS, folder };
}

export function createFolderV2Success(folderId, parentId, folderName) {
  return {
    type: types.CREATE_FOLDER_V2_SUCCESS, folderId, parentId, folderName };
}

export function addToFolderSuccess(folders) {
  return { type: types.ADD_TO_FOLDER_SUCCESS, folders };
}

export function editFolderSuccess(folderId, updates) {
  return { type: types.EDIT_FOLDER_SUCCESS, folderId, updates };
}

export function moveFolderOptimistic(folderId, updates) {
  return { type: types.MOVE_FOLDER_OPTIMISTIC, folderId, updates };
}

export function moveFolderRevert(folderId, updates) {
  return { type: types.MOVE_FOLDER_REVERT, folderId, updates};
}

export function replaceFolderOptimistic(folderMovedId, folderConflict) {
  return { type: types.REPLACE_FOLDER_OPTIMISTIC, folderMovedId, folderConflict };
}

export function replaceFolderCompletion(folderMovedId, folderConflict) {
  return { type: types.REPLACE_FOLDER_COMPLETION, folderMovedId, folderConflict};
}

export function replaceFolderRevert(folderMovedId, folderConflict) {
  return { type: types.REPLACE_FOLDER_REVERT, folderMovedId, folderConflict};
}

export function deleteFolderSuccess(folderId) {
  return { type: types.DELETE_FOLDER_SUCCESS, folderId };
}

export function shareFolderSuccess(folderId, accessor, shareOption) {
  return { type: types.SHARE_FOLDER_SUCCESS, folderId, accessor, shareOption };
}

export function removeFolderShareSuccess(folderId, accessor, data) {
  return { type: types.REMOVE_FOLDER_SHARE_SUCCESS, folderId, accessor, data};
}

export function changeItemFolderOptimistic(folderContentId, newFolder) {
  return { type: types.CHANGE_ITEM_FOLDER_OPTIMISTIC, folderContentId, newFolder };
}

export function changeItemFolderRevert(folderContentId, newFolder) {
  return { type: types.CHANGE_ITEM_FOLDER_REVERT, folderContentId, newFolder };
}

export function deleteItemFromFolderSuccess(folderContentId) {
  return { type: types.DELETE_ITEM_FROM_FOLDER_SUCCESS, folderContentId };
}

export function loadMyFolderContentSuccess(data) {
  return { type: types.LOAD_FOLDER_CONTENT_SUCCESS, data };
}

export function loadAvailableAccessorsSuccess(data) {
  return { type: types.LOAD_AVAILABLE_ACCESSORS_SUCCESS, data };
}

export function loadCurrentFolderAccessorsSuccess(folderId, data) {
  return { type: types.LOAD_CURRENT_FOLDER_ACCESSORS_SUCCESS, folderId, data };
}

export function loadMyFolders() {
  return function(dispatch) {
    return fetch(`${getAPIPath}queryapi/my-folders`, {
      method: `GET`,
      credentials: `include`,
      headers: {
        Accept: `application/json`,
      },
    })
    .then((response) => {
      response.json().then((res) => {
        dispatch(loadMyFoldersSuccess(res.data));
      });
    }).catch((error) => {
      throw (error);
    });
  };
}

export function loadMyFoldersV2(params) {
  const urlParams = [];
  for (const [key, value] of Object.entries(params || {})) {
    urlParams.push(`${key}=${JSON.stringify(value)}`);
  }
  return function(dispatch) {
    return fetch(`${getAPIPath}queryapi/my-folders?${urlParams.join(`&`)}`, {
      method: `GET`,
      credentials: `include`,
      headers: {
        Accept: `application/json`,
      },
    })
      .then((response) => {
        response.json().then((res) => {
          if (res.status_code === 200) {
            dispatch(loadMyFoldersV2Success(res.data));
          } else {
            dispatch(addNotification({
              message: res.message,
              level: `error`,
              autoDismiss: 0,
            }));
          }
        });
      })
      .catch(() => {
        dispatch(addNotification({
          message: `There was an error, please try again later`,
          level: `error`,
          autoDismiss: 0,
        }));
      });
  };
}

export function loadFolderV3(folderIds, shared) {
  let params = ``;
  if (folderIds !== undefined) {
    params = `?folder_ids=${folderIds.join(`,`)}&shared=${shared}`;
  }
  return function (dispatch) {
    return new Promise((resolve, reject) => {
      return fetch(`${getAPIPath}queryapi/user/load-folder${params}`, {
        method: `GET`,
        credentials: `include`,
        headers: {
          Accept: `application/json`,
        },
      })
        .then((response) => {
          response.json().then((res) => {
            if (res.status_code === 200) {
              dispatch(loadFolderV3Success(folderIds, res.data));
              resolve();
            } else {
              dispatch(addNotification({
                message: res.message,
                level: `error`,
                autoDismiss: 0,
              }));
              reject();
            }
          });
        })
        .catch(() => {
          dispatch(addNotification({
            message: `There was an error, please try again later`,
            level: `error`,
            autoDismiss: 0,
          }));
          reject();
        });
    });
  };
}

export function getMyFolders(params) {
  const urlParams = [];
  for (const [key, value] of Object.entries(params || {})) {
    urlParams.push(`${key}=${JSON.stringify(value)}`);
  }

  return function(dispatch) {
    return fetch(`${getAPIPath}queryapi/my-folders?${urlParams.join(`&`)}`, {
      method: `GET`,
      credentials: `include`,
      headers: {
        Accept: `application/json`,
      },
    })
      .then((response) => {
        response.json().then((res) => {
          if (res.status_code === 200) {
            dispatch(getMyFoldersSuccess(res.data));
          } else {
            dispatch(addNotification({
              message: res.message,
              level: `error`,
              autoDismiss: 0,
            }));
          }
        });
      })
      .catch(() => {
        dispatch(addNotification({
          message: `There was an error, please try again later`,
          level: `error`,
          autoDismiss: 0,
        }));
      });
  };
}

export function checkFolderExists(userId, folderName) {
  const item = {};
  item.user_id = userId;
  item.title = folderName;
  item.folder_id = 0; // Not sure why the API requires this but it does

  return function() {
    return fetch(`${getAPIPath}queryapi/user/folder`, {
      method: `GET`,
      body: JSON.stringify(item),
      credentials: `include`,
      headers: {
        Accept: `application/json`,
      },
    })
    .catch((error) => {
      throw (error);
    });
  };
}

export function createFolder(userId, folderName) {
  const item = {};
  item.user_id = userId;
  item.title = folderName;
  item.team_id_list = ``;
  item.share = `true`;

  return function(dispatch) {
    return fetch(`${getAPIPath}commandapi/user/folder`, {
      method: `POST`,
      body: JSON.stringify(item),
      credentials: `include`,
      headers: {
        Accept: `application/json`,
      },
    })
    .then((response) => {
      response.json().then((res) => {
        dispatch(createFolderSuccess(res.data));
      });
    }).catch((error) => {
      throw (error);
    });
  };
}

export function createFolderV2(parentId, folderName) {
  const params = { parent_id: parentId, title: folderName };
  return function (dispatch) {
    return new Promise((resolve, reject) => {
      fetch(`${getAPIPath}commandapi/user/folder`, {
        method: `POST`,
        body: JSON.stringify(params),
        credentials: `include`,
        headers: {
          Accept: `application/json`,
        },
      })
        .then(response => (
          response.json().then((res) => {
            if (res.status_code === 201) {
              dispatch(createFolderV2Success(res.data.id, res.data.parent_id, res.data.title));
              dispatch(addNotification({
                message: res.message,
                level: `success`,
                autoDismiss: 3,
                dismissible: `click`,
              }));
              resolve();
            } else {
              dispatch(addNotification({
                message: res.message,
                level: `error`,
                autoDismiss: 0,
              }));
              reject();
            }
          })
        ))
        .catch(() => {
          dispatch(addNotification({
            message: `There was an error, please try again later`,
            level: `error`,
            autoDismiss: 0,
          }));
          reject();
        });
    });
  };
}

export function addToFolder(folderIds, contentId, contentType) {
  const item = {};
  item.folder_ids = folderIds;
  item.content_id = contentId;
  item.content_type = contentType;

  return function(dispatch) {
    return new Promise((resolve, reject) => {
      fetch(`${getAPIPath}commandapi/user/folder/content`, {
        method: `POST`,
        body: JSON.stringify(item),
        credentials: `include`,
        headers: {
          Accept: `application/json`,
        },
      })
      .then(response => (
        response.json().then((res) => {
          if (res.status_code === 200) {
            dispatch(addToFolderSuccess(res.data));
            dispatch(addNotification({
              message: res.message,
              level: `success`,
              autoDismiss: 3,
              dismissible: `click`,
            }));
            resolve();
          } else {
            dispatch(addNotification({
              message: res.message,
              level: `error`,
              autoDismiss: 0,
            }));
            reject();
          }
        })
      )).catch((error) => {
        reject();
        throw (error);
      });
    });
  };
}

export function editFolder(folderId, updates) {
  const params = { folder_id: folderId, updates };
  return function(dispatch) {
    return new Promise((resolve, reject) => {
      fetch(`${getAPIPath}commandapi/user/folder`, {
        method: `PUT`,
        body: JSON.stringify(params),
        credentials: `include`,
        headers: {
          Accept: `application/json`,
        },
      })
        .then(response => (
          response.json().then((res) => {
            if (res.status_code === 200) {
              dispatch(editFolderSuccess(folderId, res.data));
              dispatch(addNotification({
                message: res.message,
                level: `success`,
                autoDismiss: 3,
                dismissible: `click`,
              }));
              resolve();
            } else {
              dispatch(addNotification({
                message: res.message,
                level: `error`,
                autoDismiss: 0,
              }));
              reject();
            }
          })
        )).catch(() => {
          dispatch(addNotification({
            message: `There was an error, please try again later`,
            level: `error`,
            autoDismiss: 0,
          }));
          reject();
        });
    });
  };
}

export function moveFolder(folderId, updates) {
  const params = { folder_id: folderId, updates };
  return function(dispatch) {
    return new Promise((resolve, reject) => {
      // optimistic success to prevent flickering
      dispatch(moveFolderOptimistic(folderId, updates));
      fetch(`${getAPIPath}commandapi/user/folder`, {
        method: `PUT`,
        body: JSON.stringify(params),
        credentials: `include`,
        headers: {
          Accept: `application/json`,
        },
      })
        .then(response => (
          response.json().then((res) => {
            if (res.status_code === 200) {
              dispatch(addNotification({
                message: res.message,
                level: `success`,
                autoDismiss: 3,
                dismissible: `click`,
              }));
              resolve();
            } else {
              dispatch(moveFolderRevert(folderId, updates));
              dispatch(addNotification({
                message: res.message,
                level: `error`,
                autoDismiss: 0,
              }));
              reject();
            }
          })
        )).catch(() => {
          dispatch(moveFolderRevert(folderId, updates));
          dispatch(addNotification({
            message: `There was an error, please try again later`,
            level: `error`,
            autoDismiss: 0,
          }));
          reject();
        });
    });
  };
}

export function deleteFolder(folderId) {
  return function(dispatch) {
    return new Promise((resolve, reject) => {
      fetch(`${getAPIPath}commandapi/user/folder`, {
        method: `DELETE`,
        body: JSON.stringify({ folder_id: folderId }),
        credentials: `include`,
        headers: {
          Accept: `application/json`,
        },
      })
        .then(response => (
          response.json().then((res) => {
            if (res.status_code === 200) {
              dispatch(deleteFolderSuccess(folderId));
              dispatch(addNotification({
                message: res.message,
                level: `success`,
                autoDismiss: 3,
                dismissible: `click`,
              }));
              resolve();
            } else {
              dispatch(addNotification({
                message: res.message,
                level: `error`,
                autoDismiss: 0,
              }));
              reject();
            }
          })
        )).catch(() => {
          dispatch(addNotification({
            message: `There was an error, please try again later`,
            level: `error`,
            autoDismiss: 0,
          }));
          reject();
        });
    });
  };
}

export function replaceFolder(folderMovedId, folderConflict) {
  const params = {
    folder_id: folderMovedId,
    updates: {
      parent_id: folderConflict.parent_id,
      replace_id: folderConflict.id,
    },
  };
  return function(dispatch) {
    return new Promise((resolve, reject) => {
      // optimistic success to prevent flickering
      dispatch(replaceFolderOptimistic(folderMovedId, folderConflict));
      fetch(`${getAPIPath}commandapi/user/folder`, {
        method: `PUT`,
        body: JSON.stringify(params),
        credentials: `include`,
        headers: {
          Accept: `application/json`,
        },
      })
        .then(response => (
          response.json().then((res) => {
            if (res.status_code === 200) {
              dispatch(replaceFolderCompletion(folderMovedId, folderConflict));
              dispatch(addNotification({
                message: res.message,
                level: `success`,
                autoDismiss: 3,
                dismissible: `click`,
              }));
              resolve();
            } else {
              dispatch(replaceFolderRevert(folderMovedId, folderConflict));
              dispatch(addNotification({
                message: res.message,
                level: `error`,
                autoDismiss: 0,
              }));
              reject();
            }
          })
        )).catch(() => {
          dispatch(replaceFolderRevert(folderMovedId, folderConflict));
          dispatch(addNotification({
            message: `There was an error, please try again later`,
            level: `error`,
            autoDismiss: 0,
          }));
          reject();
        });
    });
  };
}

export function shareFolder(folderId, accessor, shareOption) {
  const params = {
    folder_id: folderId,
    accessor_id: accessor.id,
    permission: shareOption,
  };
  return function(dispatch) {
    return new Promise((resolve, reject) => {
      fetch(`${getAPIPath}commandapi/user/folder/share`, {
        method: `POST`,
        body: JSON.stringify(params),
        credentials: `include`,
        headers: {
          Accept: `application/json`,
        },
      })
        .then(response => (
          response.json().then((res) => {
            if (res.status_code === 200) {
              dispatch(shareFolderSuccess(folderId, accessor, shareOption));
              dispatch(addNotification({
                message: res.message,
                level: `success`,
                autoDismiss: 3,
                dismissible: `click`,
              }));
              resolve();
            } else {
              dispatch(addNotification({
                message: res.message,
                level: `error`,
                autoDismiss: 0,
              }));
              reject();
            }
          })
        ))
        .catch(() => {
          dispatch(addNotification({
            message: `There was an error, please try again later`,
            level: `error`,
            autoDismiss: 0,
          }));
          reject();
        });
    });
  };
}

export function removeFolderShare(folderId, accessor) {
  const params = {
    folder_id: folderId,
    accessor_id: accessor.id,
  };
  return function(dispatch) {
    return new Promise((resolve, reject) => {
      fetch(`${getAPIPath}commandapi/user/folder/share`, {
        method: `DELETE`,
        body: JSON.stringify(params),
        credentials: `include`,
        headers: {
          Accept: `application/json`,
        },
      })
        .then(response => (
          response.json().then((res) => {
            if (res.status_code === 200) {
              dispatch(removeFolderShareSuccess(folderId, accessor, res.data));
              dispatch(addNotification({
                message: res.message,
                level: `success`,
                autoDismiss: 3,
                dismissible: `click`,
              }));
              resolve();
            } else {
              dispatch(addNotification({
                message: res.message,
                level: `error`,
                autoDismiss: 0,
              }));
              reject();
            }
          })
        ))
        .catch(() => {
          dispatch(addNotification({
            message: `There was an error, please try again later`,
            level: `error`,
            autoDismiss: 0,
          }));
          reject();
        });
    });
  };
}

export function changeItemFolder(folderContentId, newFolder) {
  const params = { folder_content_id: folderContentId, folder_id: newFolder };
  return function(dispatch) {
    return new Promise((resolve, reject) => {
      // optimistic success to prevent flickering
      dispatch(changeItemFolderOptimistic(folderContentId, newFolder));
      fetch(`${getAPIPath}commandapi/user/folder/content`, {
        method: `PUT`,
        body: JSON.stringify(params),
        credentials: `include`,
        headers: {
          Accept: `application/json`,
        },
      })
        .then(response => (
          response.json().then((res) => {
            if (res.status_code === 200) {
              dispatch(addNotification({
                message: res.message,
                level: `success`,
                autoDismiss: 3,
                dismissible: `click`,
              }));
              resolve();
            } else {
              dispatch(changeItemFolderRevert(folderContentId, newFolder));
              dispatch(addNotification({
                message: res.message,
                level: `error`,
                autoDismiss: 0,
              }));
              reject();
            }
          })
        ))
        .catch(() => {
          dispatch(changeItemFolderRevert(folderContentId, newFolder));
          dispatch(addNotification({
            message: `There was an error, please try again later`,
            level: `error`,
            autoDismiss: 0,
          }));
          reject();
        });
    });
  };
}

export function deleteItemFromFolder(folderContentId) {
  return function(dispatch) {
    return new Promise((resolve, reject) => {
      fetch(`${getAPIPath}commandapi/user/folder/content`, {
        method: `DELETE`,
        body: JSON.stringify({ folder_content_id: folderContentId }),
        credentials: `include`,
        headers: {
          Accept: `application/json`,
        },
      })
        .then(response => (
          response.json().then((res) => {
            if (res.status_code === 200) {
              dispatch(deleteItemFromFolderSuccess(folderContentId));
              dispatch(addNotification({
                message: res.message,
                level: `success`,
                autoDismiss: 3,
                dismissible: `click`,
              }));
              resolve();
            } else {
              dispatch(addNotification({
                message: res.message,
                level: `error`,
                autoDismiss: 0,
              }));
              reject();
            }
          })
        )).catch(() => {
          dispatch(addNotification({
            message: `There was an error, please try again later`,
            level: `error`,
            autoDismiss: 0,
          }));
          reject();
        });
    });
  };
}

export function getFolderContentData(folderContentId, contentType) {
  return function (dispatch) {
    return new Promise((resolve, reject) => {
      const baseUrl = `${getAPIPath}queryapi/user/folder/content`;
      const params = `?id=${folderContentId}&type=${contentType}`;
      return fetch(baseUrl + params, {
        method: `GET`,
        credentials: `include`,
        headers: {
          Accept: `application/json`,
        },
      })
        .then(response => (
          response.json().then((res) => {
            if (res.status_code === 200) {
              dispatch(loadMyFolderContentSuccess(res.data));
              resolve();
            } else {
              dispatch(addNotification({
                message: res.message,
                level: `error`,
                autoDismiss: 0,
              }));
              reject();
            }
          })
        ))
        .catch(() => {
          dispatch(addNotification({
            message: `There was an error, please try again later`,
            level: `error`,
            autoDismiss: 0,
          }));
          reject();
        });
    });
  };
}

export function getAvailableFolderAccessors() {
  return function (dispatch) {
    fetch(`${getAPIPath}queryapi/user/folder/share`, {
      method: `GET`,
      credentials: `include`,
      headers: {
        Accept: `application/json`,
      },
    })
      .then(response => (
        response.json().then((res) => {
          if (res.status_code === 200) {
            dispatch(loadAvailableAccessorsSuccess(res.data));
          } else {
            dispatch(addNotification({
              message: res.message,
              level: `error`,
              autoDismiss: 0,
            }));
          }
        })
      ))
      .catch(() => {
        dispatch(addNotification({
          message: `There was an error, please try again later`,
          level: `error`,
          autoDismiss: 0,
        }));
      });
  };
}

export function loadCurrentFolderAccessors(folderId) {
  return function (dispatch) {
    return new Promise((resolve, reject) => {
      fetch(`${getAPIPath}queryapi/user/folder/share?folder_id=${folderId}`, {
        method: `GET`,
        credentials: `include`,
        headers: {
          Accept: `application/json`,
        },
      })
        .then(response => (
          response.json().then((res) => {
            if (res.status_code === 200) {
              dispatch(loadCurrentFolderAccessorsSuccess(folderId, res.data));
              resolve();
            } else {
              dispatch(addNotification({
                message: res.message,
                level: `error`,
                autoDismiss: 0,
              }));
              reject();
            }
          })
        ))
        .catch(() => {
          dispatch(addNotification({
            message: `There was an error, please try again later`,
            level: `error`,
            autoDismiss: 0,
          }));
          reject();
        });
    });
  };
}



// WEBPACK FOOTER //
// ./library/app/actions/folderActions.js